//#region imports
import { Component, OnInit } from '@angular/core';
import { GuaranteeService } from 'src/app/services/guarantee.service';
import { SummaryService } from 'src/app/services/summary.service';
import { Pricing, TheftModel, TarifCheckboxStatus } from 'src/app/module/guarantee/model/guarantee.model';
import { DecimalPipe } from '@angular/common';
import { P5xService } from 'src/app/services/p5x.service';
import { SectionService } from 'src/app/services/section.service';
import { Globals } from 'src/app/services/globals';
import { DocumentService } from 'src/app/services/document.service';
import { TranslateService } from '@ngx-translate/core';
import { CharacteristicService } from 'src/app/services/characteristic.service';
import {PixelService} from 'ngx-pixel';
//#endregion

@Component({
  selector: 'app-recapitulatory-question1',
  templateUrl: './recapitulatory-question1.component.html',
  styleUrls: ['./recapitulatory-question1.component.css']
})
export class RecapitulatoryQuestion1Component implements OnInit {
  //#region variables
  initialPricingData: Pricing;
  updatedPricingData: Pricing;
  contentCovering: boolean;
  residenceprinciple: boolean;
  isHouse: boolean;
  isOwner: boolean;
  isShowtheftcheck: boolean;
  propertyDestinationRenting: boolean;
  premiumTotalAmount: number;
  premiumTotalAmountStr: string;
  batiment: number;
  batimentStr: string;
  ensuringContent: number;
  ensuringContentStr: string;
  legalProtection: number;
  legalProtectionStr: string;
  flight: number;
  flightStr: string;
  deductableReimbursement: number;
  deductableReimbursementStr: string;
  indirectLosses: number;
  indirectLossesStr: string;
  discontinuanceOfAppeal: number;
  discontinuanceOfAppealStr: string;
  ensureYourContentChecked: boolean;
  legalProtectionChecked: boolean;
  flightChecked: boolean;
  flightSubChecked: boolean;
  deductibleReimbursementChecked: boolean;
  indirectLossesChecked: boolean;
  discontinuanceOfAppealChecked: boolean;
  tarifCheckboxStatus: TarifCheckboxStatus;
  showPremiumtag: boolean = false;
  showtheftprem: boolean = false;
  //#endregion

  //#region methods
  constructor(
    private guaranteeService: GuaranteeService, private summaryService: SummaryService,
    private decimalPipe: DecimalPipe, private p5xService: P5xService, private translate: TranslateService,
    private sectionService: SectionService, private globals: Globals, private documentservice: DocumentService,
    private characteristicService: CharacteristicService, private pixel:PixelService) { }

  ngOnInit() {
    this.sectionService.setCurrentPage('P4-1');
    this.globals.trackPageActivity += ';' + 'P4-1';
    this.pixel.track('CompleteRegistration');
    this.contentCovering = this.guaranteeService.getContentCovering();
    this.isHouse = this.documentservice.getIsHouse();
    this.isOwner = this.p5xService.getIsOwner();
    this.residenceprinciple = this.guaranteeService.getResidencePrinciple() === 'false' ? false : true;
    this.propertyDestinationRenting = this.guaranteeService.getPropertyDestinationRenting();
    this.initialPricingData = this.guaranteeService.getInitialPricingData();
    this.updatedPricingData = this.guaranteeService.getUpdatedPricingData();
    this.tarifCheckboxStatus = this.guaranteeService.getTarifCheckboxStatus();
    // if(this.propertyDestinationRenting === false && this.isOwner === true && this.isHouse === true && this.residenceprinciple === false){
    //   this.isShowtheftcheck = false;
    // }
    // else{
    //   this.isShowtheftcheck = true;
    // }
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.premiumTotalAmountStr = this.updatedPricingData.Tarification.Premium_Total_Amount;
      this.batimentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Building;
      this.ensuringContentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content;
      this.legalProtectionStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
      this.flightStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft;
      this.deductableReimbursementStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund;
      this.indirectLossesStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses;
      this.discontinuanceOfAppealStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse;

      this.ensureYourContentChecked = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content_Checked;
      this.legalProtectionChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked;
      this.flightChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked;
      this.flightSubChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked;
      this.deductibleReimbursementChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked;
      this.indirectLossesChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked;
      this.discontinuanceOfAppealChecked = this.updatedPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked;
      this.guaranteeService.setNatureAbandonRecoursCheck(this.discontinuanceOfAppealChecked);
    } else {
      this.premiumTotalAmountStr = this.initialPricingData.Tarification.Premium_Total_Amount;
      this.batimentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Building;
      this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
      this.legalProtectionStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
      this.flightStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft;
      this.deductableReimbursementStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund;
      this.indirectLossesStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses;
      this.discontinuanceOfAppealStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse;

      this.ensureYourContentChecked = this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked;
      this.legalProtectionChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked;
      this.flightChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked;
      this.flightSubChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked;
      this.deductibleReimbursementChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked;
      this.indirectLossesChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked;
      this.discontinuanceOfAppealChecked = this.initialPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked;
      this.guaranteeService.setNatureAbandonRecoursCheck(this.discontinuanceOfAppealChecked);
    }
    this.premiumTotalAmount = +this.premiumTotalAmountStr.replace(',', '.');
    this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);

    this.batiment = +this.batimentStr.replace(',', '.');
    this.ensuringContent = +this.ensuringContentStr.replace(',', '.');
    this.legalProtection = +this.legalProtectionStr.replace(',', '.');
    this.flight = +this.flightStr.replace(',', '.');
    this.deductableReimbursement = +this.deductableReimbursementStr.replace(',', '.');
    this.indirectLosses = +this.indirectLossesStr.replace(',', '.');
    this.discontinuanceOfAppeal = +this.discontinuanceOfAppealStr.replace(',', '.');
    if(this.flight === 0 )
    {
      this.showtheftprem = true;
    }
    this.guaranteeService.getPremiumTotalShow().subscribe((value) => {
      this.showPremiumtag = value;
    });
    this.showPremiumtag = this.globals.isTheftZero;
    
  }

  onEnsureContentChange($event) {
    if ($event.target.checked) {
      this.updatedPricingData = null;
      this.guaranteeService.setUpdatedPricingData(null);
      this.guaranteeService.setContentCovering(true);
      this.ensureYourContentChecked = true;
      this.contentCovering = true;
      this.initialPricingData.Tarification.Premium_VAT_Fire_Content_Checked = true;
      this.tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
      this.premiumTotalAmountStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Building;
      this.premiumTotalAmount = this.convertToNumber(this.premiumTotalAmountStr);
      this.onChangeChecked(this.ensuringContent);
      this.guaranteeService.setPremiumTotalAmount(this.initialPricingData.Tarification.Premium_Total_Amount);
      this.ensuringContentStr = this.initialPricingData.Tarification.Premium_VAT_Fire_Content;
      this.ensuringContent = this.convertToNumber(this.ensuringContentStr);
      this.legalProtectionStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
      this.legalProtection = this.convertToNumber(this.legalProtectionStr);
      this.legalProtectionChecked = false;
      this.flightStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft;
      this.flight = this.convertToNumber(this.flightStr);
      this.flightChecked = false;
      this.flightSubChecked = false;
      this.deductableReimbursementStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund;
      this.deductableReimbursement = this.convertToNumber(this.deductableReimbursementStr);
      this.deductibleReimbursementChecked = false;
      this.indirectLossesStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses;
      this.indirectLosses = this.convertToNumber(this.indirectLossesStr);
      this.indirectLossesChecked = false;
      if (this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked) {
        this.legalProtectionChecked = true;
        this.premiumTotalAmount = this.premiumTotalAmount + this.legalProtection;
        this.premiumTotalAmountStr = this.convertToString(this.premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }
      if (this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked) {
        this.deductibleReimbursementChecked = true;
        this.premiumTotalAmount = this.premiumTotalAmount + this.deductableReimbursement;
        this.premiumTotalAmountStr = this.convertToString(this.premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }
      if (this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked) {
        this.indirectLossesChecked = true;
        this.premiumTotalAmount = this.premiumTotalAmount + this.indirectLosses;
        this.premiumTotalAmountStr = this.convertToString(this.premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }
      this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
    } else {
      if (this.flightSubChecked) {
        const premiumAmountVatTheft = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Administration;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = premiumAmountVatTheft;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = premiumAmountVatTheftNet;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = premiumAmountVatTheftTax;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = premiumAmountVatTheftAcquisition;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration = premiumAmountVatTheftAdministration;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
        this.flightStr = this.initialPricingData.Tarification.Premium_Amount_VAT_Theft;
        this.flight = this.convertToNumber(this.flightStr);
        this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked = false;
        this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      }
      this.updateTarificationCall('0');
      this.guaranteeService.setContentCovering(false);
      this.ensureYourContentChecked = false;
      this.contentCovering = false;
      this.flightChecked = false;
      this.flightSubChecked = false;
    }
  }

  convertToString(value: number): string {
    let valueStr = this.decimalPipe.transform(value, '0.2-2').replace(',', '');
    valueStr = valueStr.replace('.', ',');
    return valueStr;
  }

  convertToNumber(value: string): number {
    return +(value.replace(',', '.'));
  }

  updateTarificationCall(capitalContenu) {
    const request = this.guaranteeService.updateTarifRequest('false', capitalContenu);
    this.guaranteeService.getUpdatedTarificationEvaluationApi(request).subscribe((response) => {
      let capitalContenuStr;
      if (capitalContenu === '0') {
        capitalContenuStr = this.initialPricingData.Evaluation.CapitalContenuEvalue;
      } else {
        capitalContenuStr = this.decimalPipe.transform(capitalContenu, '0.2-2').replace(',', '').replace('.', ',');
      }
      this.updatedPricingData = this.guaranteeService.updateTarifEnsuringContentCalculation(capitalContenuStr, response);
      this.ensuringContentStr = this.updatedPricingData.Tarification.Premium_VAT_Fire_Content;
      this.ensuringContent = this.convertToNumber(this.ensuringContentStr);
      this.legalProtectionStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection;
      this.legalProtection = this.convertToNumber(this.legalProtectionStr);
      this.legalProtectionChecked = false;
      this.deductableReimbursementStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund;
      this.deductableReimbursement = this.convertToNumber(this.deductableReimbursementStr);
      this.deductibleReimbursementChecked = false;
      this.indirectLossesStr = this.updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses;
      this.indirectLosses = this.convertToNumber(this.indirectLossesStr);
      this.indirectLossesChecked = false;
      this.updatedPricingData.Tarification.Premium_VAT_Fire_Content_Checked = false;
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
      this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.updatedPricingData.Tarification.Premium_VAT_Fire_Building;
      this.premiumTotalAmountStr = this.updatedPricingData.Tarification.Premium_Total_Amount;
      this.premiumTotalAmount = +((this.premiumTotalAmountStr).replace(',', '.'));
      this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);

      this.tarifCheckboxStatus.Premium_VAT_Fire_Content_Checked = false;
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked = false;
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);

      if (this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked) {
        this.legalProtectionChecked = true;
        this.premiumTotalAmount = this.premiumTotalAmount + this.legalProtection;
        this.premiumTotalAmountStr = this.convertToString(this.premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }
      if (this.updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked) {
        this.deductibleReimbursementChecked = true;
        this.premiumTotalAmount = this.premiumTotalAmount + this.deductableReimbursement;
        this.premiumTotalAmountStr = this.convertToString(this.premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }
      if (this.updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked) {
        this.indirectLossesChecked = true;
        this.premiumTotalAmount = this.premiumTotalAmount + this.indirectLosses;
        this.premiumTotalAmountStr = this.convertToString(this.premiumTotalAmount);
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
      }
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
    });
  }

  onLegalProtectionChange($event) {
    if ($event.target.checked) {
      this.onChangeChecked(this.legalProtection);
      this.legalProtectionChecked = true;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Legal_Protection_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    } else {
      this.onChangeNotChecked(this.legalProtection);
      this.legalProtectionChecked = false;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Legal_Protection_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Legal_Protection_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    }
  }

  onFlightChange($event) {
    if ($event.target.checked) {
      this.p5xService.setP41TheftChecked(true);
      this.onChangeChecked(this.flight);
      if (this.flight === 0){
        const input = {
          title: this.translate.instant('Msg_Warning_Title'), 
          errorMessage: this.translate.instant('Msg_4Facades_TheftZero'),
          disableClose: false};
        this.characteristicService.serverFailError(input);   
        this.globals.isTheftZero = true;
        this.guaranteeService.setPremiumTotalShow(true);        
      }
      this.flightChecked = true;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    } else {
      if (this.flightSubChecked) {
        if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
          this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
          this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
        } else {
          this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
          this.guaranteeService.setInitialPricingData(this.initialPricingData);
        }
        this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
        this.flightSubChecked = false;
        this.reset();
      }
      this.p5xService.setP41TheftChecked(false);
      this.onChangeNotChecked(this.flight);
      if (this.flight === 0){
        this.globals.isTheftZero = false;
        this.guaranteeService.setPremiumTotalShow(false);
      }
      this.flightChecked = false;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    }
  }

  onFlightSubChange($event) {
    if ($event.target.checked) {
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.flightSubChecked = true;
      this.updateTarifTheftCall();
    } else {
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Theft_WithAlarm_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
      this.flightSubChecked = false;
      this.reset();
    }
  }

  updateTarifTheftCall() {
    this.guaranteeService.getFlightSubject().subscribe((value) => {
      this.flightStr = value.Premium_Amount_VAT_Theft;
      this.updatedPricingData = this.guaranteeService.getUpdatedPricingData();
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft = this.flightStr;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Net = value.Premium_Amount_VAT_Theft_Net;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = value.Premium_Amount_VAT_Theft_Tax;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = value.Premium_Amount_VAT_Theft_Acquisition;
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Theft_Administration =
          value.Premium_Amount_VAT_Theft_Administration;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft = this.flightStr;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Net = value.Premium_Amount_VAT_Theft_Net;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Tax = value.Premium_Amount_VAT_Theft_Tax;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Acquisition = value.Premium_Amount_VAT_Theft_Acquisition;
        this.initialPricingData.Tarification.Premium_Amount_VAT_Theft_Administration =
          value.Premium_Amount_VAT_Theft_Administration;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
    });
    let capitalContenu;
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      capitalContenu = this.updatedPricingData.Tarification.CapitalContenuEvalue;
    } else {
      capitalContenu = this.initialPricingData.Tarification.CapitalContenuEvalue;
    }
    const request = this.guaranteeService.updateTarifRequest('true', capitalContenu.replace(',', '.'));
    this.guaranteeService.getUpdatedTarificationEvaluationApi(request).subscribe((response) => {
      // console.log(response);
      this.guaranteeService.updateTarifTheftCalculation(response);
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.premiumTotalAmount = +((this.updatedPricingData.Tarification.Premium_Total_Amount).replace(',', '.'));
      } else {
        this.premiumTotalAmount = +((this.initialPricingData.Tarification.Premium_Total_Amount).replace(',', '.'));
      }
    }, (error) => {
      this.flightSubChecked = false;
    });
  }

  reset() {
    let currentFlightValue;
    let theftObj: TheftModel;
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      if (this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft) {
        const premiumAmountVatTheft = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupUpdatedFlight().Premium_Amount_VAT_Theft_Administration;
        theftObj = {
          Premium_Amount_VAT_Theft: premiumAmountVatTheft,
          Premium_Amount_VAT_Theft_Net: premiumAmountVatTheftNet,
          Premium_Amount_VAT_Theft_Tax: premiumAmountVatTheftTax,
          Premium_Amount_VAT_Theft_Acquisition: premiumAmountVatTheftAcquisition,
          Premium_Amount_VAT_Theft_Administration: premiumAmountVatTheftAdministration
        };
        this.flightStr = premiumAmountVatTheft;
        this.flight = this.convertToNumber(this.flightStr);
        const originalFlightValue2 = +premiumAmountVatTheft.replace(',', '.');
        currentFlightValue = +this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
        this.premiumTotalAmountStr = this.guaranteeService.getUpdatedPricingData().Tarification.Premium_Total_Amount.toString();
        this.premiumTotalAmount = +(this.premiumTotalAmountStr.replace(',', '.')) -
          (+(this.decimalPipe.transform(currentFlightValue, '0.2-2').replace(',', ''))) + originalFlightValue2;
        this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '').replace('.', ',');
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
        this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      }
    } else {
      if (this.guaranteeService.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft) {
        const premiumAmountVatTheft = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft;
        const premiumAmountVatTheftNet = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Net;
        const premiumAmountVatTheftTax = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Tax;
        const premiumAmountVatTheftAcquisition = this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Acquisition;
        const premiumAmountVatTheftAdministration =
          this.guaranteeService.getBackupFlight().Premium_Amount_VAT_Theft_Administration;
        theftObj = {
          Premium_Amount_VAT_Theft: premiumAmountVatTheft,
          Premium_Amount_VAT_Theft_Net: premiumAmountVatTheftNet,
          Premium_Amount_VAT_Theft_Tax: premiumAmountVatTheftTax,
          Premium_Amount_VAT_Theft_Acquisition: premiumAmountVatTheftAcquisition,
          Premium_Amount_VAT_Theft_Administration: premiumAmountVatTheftAdministration
        };
        this.flightStr = premiumAmountVatTheft;
        this.flight = this.convertToNumber(this.flightStr);
        const originalFlightValue2 = +premiumAmountVatTheft.replace(',', '.');
        currentFlightValue = +this.guaranteeService.getInitialPricingData().Tarification.Premium_Amount_VAT_Theft.replace(',', '.');
        this.premiumTotalAmountStr = this.guaranteeService.getInitialPricingData().Tarification.Premium_Total_Amount.toString();
        this.premiumTotalAmount = +(this.premiumTotalAmountStr.replace(',', '.')) -
          (+(this.decimalPipe.transform(currentFlightValue, '0.2-2').replace(',', ''))) + originalFlightValue2;
        this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '').replace('.', ',');
        this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
        this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
    }
    this.guaranteeService.setFlightSubject(theftObj);
  }

  onDeductibleReimbursementChange($event) {
    if ($event.target.checked) {
      this.onChangeChecked(this.deductableReimbursement);
      this.deductibleReimbursementChecked = true;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Deductible_Refund_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    } else {
      this.onChangeNotChecked(this.deductableReimbursement);
      this.deductibleReimbursementChecked = false;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Deductible_Refund_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Deductible_Refund_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    }
  }

  onIndirectLossesChange($event) {
    if ($event.target.checked) {
      this.onChangeChecked(this.indirectLosses);
      this.indirectLossesChecked = true;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Indirect_Losses_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    } else {
      this.onChangeNotChecked(this.indirectLosses);
      this.indirectLossesChecked = false;
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Indirect_Losses_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Indirect_Losses_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    }
  }

  onDiscontinuanceOfAppealChange($event) {
    if ($event.target.checked) {
      this.onChangeChecked(this.discontinuanceOfAppeal);
      this.discontinuanceOfAppealChecked = true;
      this.guaranteeService.setNatureAbandonRecoursCheck(true);
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked = true;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked = true;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Waiver_Of_Recourse_Checked = true;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    } else {
      this.onChangeNotChecked(this.discontinuanceOfAppeal);
      this.discontinuanceOfAppealChecked = false;
      this.guaranteeService.setNatureAbandonRecoursCheck(false);
      if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
        this.updatedPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked = false;
        this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
      } else {
        this.initialPricingData.Tarification.Premium_Amount_VAT_Waiver_Of_Recourse_Checked = false;
        this.guaranteeService.setInitialPricingData(this.initialPricingData);
      }
      this.tarifCheckboxStatus.Premium_Amount_VAT_Waiver_Of_Recourse_Checked = false;
      this.guaranteeService.setTarifCheckboxStatus(this.tarifCheckboxStatus);
    }
  }

  onChangeChecked(value) {
    this.summaryService.setSummaryProgressBarDetails();
    if(this.globals.isMobile)
    {this.summaryService.setmobileSummaryProgressBarDetails();}
    this.premiumTotalAmount = this.premiumTotalAmount + value;
    this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '');
    this.premiumTotalAmountStr = this.premiumTotalAmountStr.replace('.', ',');
    this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
    } else {
      this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
    }
  }

  onChangeNotChecked(value) {
    this.summaryService.setSummaryProgressBarDetails();
    if(this.globals.isMobile)
    {this.summaryService.setmobileSummaryProgressBarDetails();}
    this.premiumTotalAmount = this.premiumTotalAmount - value;
    this.premiumTotalAmountStr = this.decimalPipe.transform(this.premiumTotalAmount, '0.2-2').replace(',', '');
    this.premiumTotalAmountStr = this.premiumTotalAmountStr.replace('.', ',');
    this.guaranteeService.setPremiumTotalAmount(this.premiumTotalAmountStr);
    if (this.updatedPricingData !== undefined && this.updatedPricingData !== null) {
      this.updatedPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.guaranteeService.setUpdatedPricingData(this.updatedPricingData);
    } else {
      this.initialPricingData.Tarification.Premium_Total_Amount = this.premiumTotalAmountStr;
      this.guaranteeService.setInitialPricingData(this.initialPricingData);
    }
  }
  //#endregion
}
